import React from 'react'
import TspData from './TspData';
import useFetch from '../../hooks/useFetch';

export default function TSP() {

  const { data, isLoading } = useFetch('tsp')

  if (isLoading) {
    return (
      <>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
          </div>
        </main>
      </>
    )
  }

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">TSP Report</h1>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Scope</th>
                <th scope="col">Year</th>
                <th scope="col">Supplier</th>
                <th scope="col">Category</th>
                <th scope="col">Source</th>
                <th scope="col">Discription</th>
                <th scope="col">Groundwater</th>
                <th scope="col">Surface water</th>
                <th scope="col">Sea water</th>
                <th scope="col">Third party</th>
                <th scope="col">Produced</th>
                <th scope="col">Nox</th>
                <th scope="col">Sox</th>
                <th scope="col">Pm</th>
                <th scope="col">Pb</th>
                <th scope="col">Hg</th>
                <th scope="col">Total</th>
              </tr>
            </thead>
            <tbody>
              <TspData data={data} />
            </tbody>
          </table>
        </div>
      </main>
    </>
  )
}
